<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Ministerio di Hustisia</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>About</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>



 

<div class="popular-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="popular-item">
                    <div class="row align-items-center">
                        <div class="col-lg-10">
                            <img src="assets/img/home-1/3.jpg" alt="Popular">
                        </div>

     
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="popular-item popular-right">
                    <div class="section-title text-start">
                        <h2>Ministerio di Hustisia di Kòrsou </h2> 
                    </div>
                   
                      
                       <p>
                       Nos ta e wesu di lomba di un komunidat safe, liber i hustu. Kaminda tur hende, independientemente di su estilo di bida òf kreensia, por biba den harmonia ku otro.
                        </p>
                        <p>
                            Den Hustisia nos ta aspirá pa krea un komunidat mas safe i hustu, no únikamente brindando protekshon, pero tambe, kaminda ta nesesario, guia pa medio di intervenshon. Nos akshonnan ta habri porta nobo i ta ofresé perspektiva nobo, ku e kapasidat úniko pa tuma desishonnan transendente. Pasobra lei ta toka nos tur. 
                        </p>
                   
      


                </div>
            </div>
        </div>
    </div>
</div>